import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import CamperCard from "../shared/CamperCard";
import { useVehicles } from "../../context/VehicleContext";
import { useTranslation } from "../../hooks/useTranslation";
import ReactGA from "react-ga4";

const VanShowcase = () => {
  const { vehicles: vans, loading, error } = useVehicles();
  const [selectedCategory, setSelectedCategory] = useState("all");
  const navigate = useNavigate();
  const { t, getLocalizedPath } = useTranslation('home');

  const chips = [
    { text: t('vehicles.categories.all'), category: "all" },
    { text: t('vehicles.categories.family'), category: "family" },
    { text: t('vehicles.categories.surf'), category: "surf" },
    { text: t('vehicles.categories.nomads'), category: "nomads" },
  ];

  // Filter vehicles based on selected category
  const filteredVans = useMemo(() => {
    if (!vans || !Array.isArray(vans)) return [];

    if (selectedCategory === "all") {
      return vans.slice(0, 3);
    }

    const filtered = vans.filter((van) => {
      // Check if vehicle has the selected category
      const hasCategory = (cat) => {
        // Check single category field (backward compatibility)
        if (van.category && van.category.includes(cat)) {
          return true;
        }
        // Check categories array
        if (van.categories && Array.isArray(van.categories)) {
          return van.categories.includes(cat);
        }
        return false;
      };

      return hasCategory(selectedCategory);
    });

    return filtered.slice(0, 3);
  }, [vans, selectedCategory]);

  const handleCategoryChange = (category) => {
    ReactGA.event({
      category: 'Filter',
      action: 'Category Change',
      label: `homepage_${category}`
    });
    setSelectedCategory(category);
  };

  const handleShowAllCampers = () => {
    ReactGA.event({
      category: 'CTA',
      action: 'Show All Campers',
      label: 'homepage'
    });
    navigate(getLocalizedPath('/catalog'));
  };

  return (
    <div className="van-showcase">
      <div className="showcase-container">
        <div className="showcase-header">
          <h2 className="showcase-title">
            {t('vehicles.title')}
          </h2>
          <div className="chip-groups">
            {chips.map((chip, index) => (
              <div
                key={index}
                className={`chip ${selectedCategory === chip.category ? "chip-active" : ""}`}
                onClick={() => handleCategoryChange(chip.category)}
                style={{ cursor: "pointer" }}
              >
                <div className="chip-state-layer">{chip.text}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="van-list">
          {loading ? (
            <div>{t('vehicles.loading')}</div>
          ) : error ? (
            <div style={{ color: 'red' }}>{t('vehicles.error')}: {error}</div>
          ) : filteredVans && filteredVans.length > 0 ? (
            filteredVans.map((van, index) => (
              <CamperCard key={index} vehicle={van} variant="homepage" />
            ))
          ) : (
            <div>{t('vehicles.noVehicles')}</div>
          )}
        </div>
        <div className="show-all-button" onClick={handleShowAllCampers} style={{ cursor: 'pointer' }}>
          <div className="button-state-layer">{t('vehicles.showAll')}</div>
        </div>
      </div>
    </div>
  );
};

export default VanShowcase;
